<template>
  <div class="home">
    <van-nav-bar title="蓝耳病净化服务" v-if="isWx==1" left-arrow @click-left="onClickLeft" fixed></van-nav-bar>
    <van-nav-bar title="蓝耳病净化服务" v-else fixed></van-nav-bar>
    <div class="navheight"></div>
    <div class="swine_wrap">
      <div class="swine_box">
        <p class="wrap_p">结论（净化目标）</p>
        <p class="result">{{answer_text}}</p>
        <p class="wrap_p">免疫措施</p>
        <div class="step">
          <p class="sow_res" v-if="num1>0">
            <span class="result_title">母猪</span>
            <span id="sow_res">{{list.sow_res[0].answer_text}}</span>
          </p>
          <p class="boar_res" v-if="num2>0">
            <span class="result_title">公猪</span>
            <span id="boar_res">{{list.boar_res[0].answer_text}}</span>
          </p>
          <p class="commercial_res" v-if="num3>0">
            <span class="result_title">商品猪</span>
            <span id="commercial_res">{{list.commercial_res[0].answer_text}}</span>
          </p>
        </div>  
      </div>
      <van-tabs>
        <van-tab title="母猪">
          <div class="nav_info"><!--母猪-->
            <h2>群体监测</h2>
            <table>
              <tr>
                <td rowspan="4" style="width:20%">监测方法</td>
                <td style="width:20%">监测比例</td>
                <td style="width:60%">25%（100头以上）</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>1次/半年</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体和抗原</td>
              </tr>
              <tr>
                <td>备注</td>
                <td></td>
              </tr>
                <tr>
                <td>监测结果</td>
                <td colspan="2">生产母猪发现猪繁殖与呼吸综合征抗体抗体不合格者，应加强免疫。</td>
              </tr>
            </table>
            <h2>免疫净化</h2>
            <table>
              <tr>
                <td rowspan="4" style="width:20%">监测方法</td>
                <td style="width:20%;">监测比例</td>
                <td style="width:60%;">25%</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>1次/季度</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体和抗原</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>确保一年内，假定阴性群生产母猪普检完毕。有条件的养殖场，可一次性100%检测，缩短净化周期。</td>
              </tr>
                <tr>
                <td>监测结果</td>
                <td colspan="2">猪繁殖与呼吸综合征非免疫场如发现猪繁殖与呼吸综合征抗体阳性的隐性带毒者，立即淘汰</td>
              </tr>
              <tr>
                <td rowspan="4">净化维持</td>
                <td>监测比例</td>
                <td>30头以上</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>1次/季度</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>了解猪群抗体情况，是否存在野毒循环。</td>
              </tr>
            </table>
            <h2>非免疫净化</h2>
            <table>
              <tr>
                <td rowspan="4" style="width:20%">监测方法</td>
                <td style="width:20%">监测比例</td>
                <td style="width:60%">25%</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>1次/季度</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体和抗原</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>确保一年内，假定阴性群生产母猪普检完毕。有条件的养殖场，可一次性100%检测，缩短净化周期。</td>
              </tr>
              <tr>
                <td>监测结果</td>
                <td colspan="2">猪繁殖与呼吸综合征非免疫场如发现猪繁殖与呼吸综合征抗体阳性的隐性带毒者，立即淘汰</td>
              </tr>
              <tr>
                <td rowspan="4">净化维持</td>
                <td>监测比例</td>
                <td>30头以上</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>1次/季度</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>了解猪群抗体情况，是否存在野毒循环。</td>
              </tr>
            </table>
          </div>
        </van-tab>
        <van-tab title="公猪">
          <div class="nav_info"><!--公猪-->
            <h2>群体监测</h2>
            <table>
              <tr>
                <td rowspan="4" style="width:20%">监测方法</td>
                <td style="width:20%">监测比例</td>
                <td style="width:60%">100%</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>1次/半年</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体和抗原</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>只有猪繁殖与呼吸综合征免疫抗体合格及猪繁殖与呼吸综合征病原学阴性的猪，方可留用。</td>
              </tr>
              <tr>
                <td>监测结果</td>
                <td colspan="2">种公猪发现猪繁殖与呼吸综合征抗体抗体不合格者，应加强免疫。</td>
              </tr>
            </table>
            <h2>免疫净化</h2>
            <table>
              <tr>
                <td rowspan="4" style="width:20%">监测方法</td>
                <td style="width:20%">监测比例</td>
                <td style="width:60%">100%</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>1次/半年</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体和抗原</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>只有猪繁殖与呼吸综合征免疫抗体阴性及猪繁殖与呼吸综合征病原学阴性的猪，方可留用。</td>
              </tr>
              <tr>
                <td>监测结果</td>
                <td colspan="2">猪繁殖与呼吸综合征非免疫场如发现猪繁殖与呼吸综合征抗体阳性的隐性带毒者，立即淘汰</td>
              </tr>
              <tr>
                <td rowspan="4">净化维持</td>
                <td>监测比例</td>
                <td>100%</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>1次/半年</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体和抗原</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>只有猪繁殖与呼吸综合征免疫抗体阴性的猪，方可留用。</td>
              </tr>
            </table>
            <h2>非免疫净化</h2>
            <table>
              <tr>
                <td rowspan="4" style="width:20%">监测方法</td>
                <td style="width:20%;">监测比例</td>
                <td style="width:60%;">100%</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>1次/半年</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体和抗原</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>只有猪繁殖与呼吸综合征免疫抗体阴性及猪繁殖与呼吸综合征病原学阴性的猪，方可留用。</td>
              </tr>
              <tr>
                <td>监测结果</td>
                <td colspan="2">猪繁殖与呼吸综合征非免疫场如发现猪繁殖与呼吸综合征抗体阳性的隐性带毒者，立即淘汰</td>
              </tr>
              <tr>
                <td rowspan="4">净化维持</td>
                <td>监测比例</td>
                <td>100%</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>1次/半年</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>只有猪繁殖与呼吸综合征免疫抗体阴性的猪，方可留用。</td>
              </tr>
            </table>
          </div>
        </van-tab>
        <van-tab title="引进种猪">
          <div class="nav_info"><!-- 引进种猪 -->
            <h2>群体监测</h2>
            <table>
              <tr>
                <td rowspan="4" style="width:20%">监测方法</td>
                <td style="width:20%">监测比例</td>
                <td style="width:60%">100%</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>混群前一次；混群后纳入生产母猪/种公猪监测范畴。</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体和抗原</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>只有猪繁殖与呼吸综合征免疫抗体合格及猪繁殖与呼吸综合征病原学阴性的猪，方可混群。外购精液，应确保猪繁殖与呼吸综合征病原学阴性。</td>
              </tr>
              <tr>
                <td style="width:2rem;">监测结果</td>
                <td colspan="2">引种猪群发现猪繁殖与呼吸综合征抗体不合格者，应加强免疫。引进种猪如发现病原学阳性，坚决淘汰</td>
              </tr>
            </table>
            <h2>免疫净化</h2>
            <table>
              <tr>
                <td rowspan="4" style="width:20%;">监测方法</td>
                <td style="width:20%;">监测比例</td>
                <td style="width:60%;">100%</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>混群前一次；混群后纳入生产母猪/种公猪监测范畴。</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体和抗原</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>只有猪繁殖与呼吸综合征免疫抗体阴性且猪繁殖与呼吸综合征病原学阴性的猪，方可混群。外购精液，应确保猪繁殖与呼吸综合征病原学阴性。</td>
              </tr>
              <tr>
                <td>监测结果</td>
                <td colspan="2">猪繁殖与呼吸综合征非免疫场如发现猪繁殖与呼吸综合征抗体阳性的隐性带毒者，立即淘汰</td>
              </tr>
              <tr>
                <td rowspan="4">净化维持</td>
                <td>监测比例</td>
                <td>100%</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>混群前一次；混群后纳入生产母猪/种公猪监测范畴。</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体和抗原</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>只有猪繁殖与呼吸综合征免疫抗体阴性且猪繁殖与呼吸综合征病原学阴性的猪，方可混群。外购精液，应确保猪繁殖与呼吸综合征病原学阴性。</td>
              </tr>
            </table>
            <h2>非免疫净化</h2>
            <table>
              <tr>
                <td rowspan="4" style="width:20%;">监测方法</td>
                <td style="width:20%;">监测比例</td>
                <td style="width:60%;">100%</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>混群前一次；混群后纳入生产母猪/种公猪监测范畴。</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体和抗原</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>只有猪繁殖与呼吸综合征免疫抗体阴性且猪繁殖与呼吸综合征病原学阴性的猪，方可混群。外购精液，应确保猪繁殖与呼吸综合征病原学阴性。</td>
              </tr>
              <tr>
                <td>监测结果</td>
                <td colspan="2">猪繁殖与呼吸综合征非免疫场如发现猪繁殖与呼吸综合征抗体阳性的隐性带毒者，立即淘汰</td>
              </tr>
              <tr>
                <td rowspan="4">净化维持</td>
                <td>监测比例</td>
                <td>100%</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>混群前一次；混群后纳入生产母猪/种公猪监测范畴。</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>只有猪繁殖与呼吸综合征免疫抗体阴性的猪，方可混群。外购精液，应确保猪繁殖与呼吸综合征病原学阴性。</td>
              </tr>
            </table>
          </div>
        </van-tab>
        <van-tab title="后备猪">
          <div class="nav_info"><!-- 后备猪 -->
            <h2>群体监测</h2>
            <table>
              <tr>
                <td rowspan="4" style="width:20%">监测方法</td>
                <td style="width:20%">监测比例</td>
                <td style="width:60%">100%</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>混群前一次；混群后纳入生产母猪/种公猪监测范畴。</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体和抗原</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>只有猪繁殖与呼吸综合征免疫抗体合格及猪繁殖与呼吸综合征病原学阴性的猪，方可混群。</td>
              </tr>
              <tr>
                <td>监测结果</td>
                <td colspan="2">后备种猪发现猪繁殖与呼吸综合征抗体不合格者，应加强免疫</td>
              </tr>
            </table>
            <h2>免疫净化</h2>
            <table>
              <tr>
                <td rowspan="4" style="width:20%">监测方法</td>
                <td style="width:20%">监测比例</td>
                <td style="width:60%">100%</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>混群前一次；混群后纳入生产母猪/种公猪监测范畴。</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体和抗原</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>只有猪繁殖与呼吸综合征免疫抗体阴性的猪，方可混群。</td>
              </tr>
              <tr>
                <td>监测结果</td>
                <td colspan="2">混群前一次；混群后纳入生产母猪/种公猪监测范畴。</td>
              </tr>
              <tr>
                <td rowspan="4">净化维持</td>
                <td>监测比例</td>
                <td>100%</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>混群前一次；混群后纳入生产母猪/种公猪监测范畴。</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体和抗原</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>只有猪繁殖与呼吸综合征免疫抗体阴性的猪，方可混群。</td>
              </tr>
            </table>
            <h2>非免疫净化</h2>
            <table>
              <tr>
                <td rowspan="4" style="width:20%">监测方法</td>
                <td style="width:20%">监测比例</td>
                <td style="width:60%">100%</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>混群前一次；混群后纳入生产母猪/种公猪监测范畴。</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体和抗原</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>只有猪繁殖与呼吸综合征免疫抗体阴性及猪繁殖与呼吸综合征病原学阴性的猪，方可混群。</td>
              </tr>
              <tr>
                <td  style="width:2rem;">监测结果</td>
                <td colspan="2">猪繁殖与呼吸综合征非免疫场如发现猪繁殖与呼吸综合征抗体阳性的隐性带毒者，立即淘汰</td>
              </tr>
              <tr>
                <td rowspan="4">净化维持</td>
                <td>监测比例</td>
                <td>100%</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>混群前一次；混群后纳入生产母猪/种公猪监测范畴。</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>只有猪繁殖与呼吸综合征免疫抗体阴性的猪，方可混群。</td>
              </tr>
            </table>
          </div>
        </van-tab>
        <van-tab title="育肥猪">
          <div class="nav_info"><!-- 育肥猪 -->
            <h2>群体监测</h2>
            <table>
              <tr>
                <td rowspan="4" style="width:20%">监测方法</td>
                <td style="width:20%">监测比例</td>
                <td style="width:60%">30头以上</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>与生产母猪监测（采样）同步</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>10周龄以上育肥猪，了解育肥猪群抗体情况，及时调整免疫程序；了解是否存在野毒循环。</td>
              </tr>
              <tr>
                <td>监测结果</td>
                <td colspan="2">育肥猪如发现猪繁殖与呼吸综合征抗体合格率低于70%或抗体整齐度较低，应调整免疫程序，并跟踪种猪群的免疫抗体情况</td>
              </tr>
            </table>
            <h2>免疫净化</h2>
            <table>
              <tr>
                <td rowspan="4" style="width:20%">监测方法</td>
                <td style="width:20%">监测比例</td>
                <td style="width:60%">30头以上</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>与生产母猪监测（采样）同步</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>10周龄以上育肥猪，了解育肥猪群抗体情况，了解是否存在野毒循环</td>
              </tr>
              <tr>
                <td>监测结果</td>
                <td colspan="2">猪繁殖与呼吸综合征非免疫场如发现猪繁殖与呼吸综合征抗体阳性的隐性带毒者，立即淘汰</td>
              </tr>
              <tr>
                <td rowspan="4">净化维持</td>
                <td>监测比例</td>
                <td>30头以上</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>与生产母猪监测（采样）同步</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>10周龄以上育肥猪，了解育肥猪群抗体情况，了解是否存在野毒循环。</td>
              </tr>
            </table>
            <h2>非免疫净化</h2>
            <table>
              <tr>
                <td rowspan="4" style="width:20%">监测方法</td>
                <td style="width:20%">监测比例</td>
                <td style="width:60%">30头以上</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>与生产母猪监测（采样）同步</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>10周龄以上育肥猪，了解育肥猪群抗体情况，了解是否存在野毒循环。</td>
              </tr>
              <tr>
                <td>监测结果</td>
                <td colspan="2">猪繁殖与呼吸综合征非免疫场如发现猪繁殖与呼吸综合征抗体阳性的隐性带毒者，立即淘汰</td>
              </tr>
              <tr>
                <td rowspan="4">净化维持</td>
                <td>监测比例</td>
                <td>30头以上</td>
              </tr>
              <tr>
                <td>检测频率</td>
                <td>与生产母猪监测（采样）同步</td>
              </tr>
              <tr>
                <td>监测内容</td>
                <td>猪繁殖与呼吸综合征抗体</td>
              </tr>
              <tr>
                <td>备注</td>
                <td>10周龄以上育肥猪，了解育肥猪群抗体情况，了解是否存在野毒循环</td>
              </tr>
            </table>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div class="btn">
      <div class="btn_next" @click="restul">重新检测</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getresults } from '@/api/resetApi.js'

export default {
  name: 'Home',
  data(){
    return{
      num1: '',
      num2: '',
      num3: '',
      answer_text: '',
      isWx: 1,
      list: [],
    }
  },
  computed: {
    ...mapGetters([
      'blueearlist',
      'blueeardata'
    ]),
  },
  created(){
    const ua = window.navigator.userAgent.toLowerCase();
    if(ua.indexOf('micromessenger') == -1) {
      this.isWx = 1
    }else{
      this.isWx = 2
    }
    this.getresults()
  },
  methods: {
    async getresults() {
      let qs = require('qs');
      let data = qs.stringify(this.blueearlist)
      const res = await getresults(data)
      console.log(res)
      try {
        if (res.data.code === 1) {
          this.list = res.data.obj[0]
          this.answer_text = this.list.target_pur[0].answer_text
          this.num1 = this.list.sow_res.length
          this.num2 = this.list.boar_res.length
          this.num3 = this.list.commercial_res.length
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    onClickLeft() {
      this.$router.back(-1)
    },
    restul() {
      this.$store.state.report.blueearlist = []
      this.$store.state.report.blueeardata = []
      this.$router.back(-1)
    },
  }
}
</script>

<style lang="scss">
.navheight {
  height: 46px;
}
.swine_wrap {
  padding: 20px 0 10px;
  .swine_box {
    padding: 0 15px;
    font-size: 14px;
    .wrap_p{
      text-align: left;
      border-left: 4px solid #388BEB;
      margin: 10px 0;
      padding: 0 10px;
    }
    .result{
      text-align: left;
      padding: 10px;
      color:#F5A623;
    }
    .step {
      text-align: left;
      line-height: 20px;
      p {
        margin: 10px 0;
        .result_title{
          padding: 4px;
          background: #388BEB;
          color: #fff!important;
          border-radius: 5px;
          margin-right: 5px; 
        }
        span {
          text-align: left;
          color: #818181;
          font-size: 12px;
        }
      }
    }
    
  }
}
.nav_info{
  padding: 15px;
  h2{
    width: 100%;
    height: 30px;
    background: #388BEB;
    color:#fff;
    line-height: 30px;
    text-indent: 10px;
    border-radius: 5px 5px 0 0;
    font-size: 14px;
    margin-top: 10px;
  }
  table{
    width:100%;
    color:#333333;
    border-width: 1px;
    border-color: #EDF6FF;
    border-collapse: collapse;
    tr {
      td {
        vertical-align: middle;
        border: 1px solid #EDF6FF;
        text-align: center;
        font-size: 14px;
        height: 30px;
        line-height: 20px;
        p {
          font-size: 14px;
        }
        &:last-child{
          text-align: left!important;
          padding: 10px;
        }
      }
    }
  }
}
.btn {
  padding: 20px 20px 50px 20px;
  .btn_next{
    font-size: 14px;
    width:100%;
    height: 40px;
    border-radius: 20px;
    color: #fff;
    background: #F5A623;
    text-align: center;
    line-height: 40px;
  }
}
</style>
